import React, { Component } from 'react';
import s from './HomeSettingsForm.css';
import { Field, reduxForm, getFormValues, change, formValueSelector } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
//Style
import cx from 'classnames';
import {
    Form,
    Col,
    Row,
    FormGroup,
    FormControl,
    Container
} from 'react-bootstrap';
import Link from '../../Link/Link';
import messages from '../../../locale/messages';
import validate from './validate';
import Dropzone from './Dropzone.js'
import Loader from '../../Common/Loader';
import { api, homepageUploadDir } from '../../../config';
//image
import defaultIcon from '../../../../public/Icons/defaultIconAdmin.svg';

export class HomeSettingsForm extends Component {

    renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, maxlength }) => {
        const { formatMessage } = this.props.intl
        return (
            <Form.Group className={cx('positionRelative', s.noMargin)}>
                <Form.Label className={'inputLabel'}>{label}</Form.Label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={cx(fieldClass, s.formControlInput)} maxLength={maxlength} />
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        )
    }

    renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl
        return (
                <FormGroup className={cx(s.space5, 'positionRelative')}>
                    <label className={'inputLabel'}>{label}</label>
                    <FormControl
                        {...input}
                        className={className}
                        placeholder={label}
                        as="textarea"
                        rows="4"
                    >
                        {children}
                    </FormControl>
                    {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
                </FormGroup>
        );
    }

    render() {
        const { handleSubmit, loading, submitting, homeSectionImage1, homeSectionImage2, homeSectionImage3,
            homeSectionImage4, homeSectionImage5, homeSectionImage6 } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div>
                <Container fluid>
                    <h1 className={cx(s.heading, 'textAlignRightRTL')}>{formatMessage(messages.homeSectionSettings)}</h1>
                    <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} className={s.blackCenter}>
                                <div className={s.blackCenterSection}>

                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <Row>
                                            <Col lg={6} md={12} sm={12} xs={12}>
                                                <Form.Group className={s.space5}>
                                                    <div className={cx(s.profileImgSection, s.profileImgWidth)}>
                                                        <label>{formatMessage(messages.homeImage1)}</label><br />
                                                        {homeSectionImage1 &&
                                                            <div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + homepageUploadDir}medium_${homeSectionImage1})` }} />
                                                        }
                                                        {
                                                            !homeSectionImage1 &&
                                                            <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
                                                        }
                                                        <div>
                                                            <Dropzone
                                                                className={cx(s.btnSecondary, s.profileNoPadding)}
                                                                subTextClass={s.subText}
                                                                fieldName={'homeSectionImage1'}
                                                                subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                                defaultMessage={formatMessage(messages.chooseFile)}
                                                                inputContainer={'.dzInputContainerHomeImage1'}
                                                                inputContainerClass={'dzInputContainerHomeImage1'}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col lg={6} md={12} sm={12} xs={12}>
                                                <Form.Group className={s.space5}>
                                                    <div className={cx(s.profileImgSection, s.profileImgWidth)}>
                                                        <label>{formatMessage(messages.homeImage2)}</label><br />
                                                        {
                                                            homeSectionImage2 &&
                                                            <div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + homepageUploadDir}medium_${homeSectionImage2})` }} />
                                                        }
                                                        {
                                                            !homeSectionImage2 &&
                                                            <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
                                                        }
                                                        <div>
                                                            <Dropzone
                                                                className={cx(s.btnSecondary, s.profileNoPadding)}
                                                                subTextClass={s.subText}
                                                                fieldName={'homeSectionImage2'}
                                                                subText={formatMessage(messages.maximumUploadSizeLabel)}
                                                                defaultMessage={formatMessage(messages.chooseFile)}
                                                                inputContainer={'.dzInputContainerHomeImage2'}
                                                                inputContainerClass={'dzInputContainerHomeImage2'}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                        <Field name="homeSectionTitle1" type="text" component={this.renderField} label={formatMessage(messages.homeTitle)} maxLength={250} />
                                            </Col>
                                            {/* <Col lg={12} md={12} sm={12} xs={12}>
                                                <Form.Group className={s.space3}>
                                                    <div>
                                                        <Field name="homeSectionDescription" type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.homePageDescription)} />
                                                    </div>
                                                </Form.Group>
                                            </Col> */}

                                        </Row>
                                    </Col>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop1, s.bottomPadding, 'textAlignLeftRTL', 'bottomPaddingRTL')}>
                                <Form.Group className={s.noMargin}>
                                    <div className={s.displayInlineBlock}>
                                        <Loader
                                            type={"button"}
                                            label={formatMessage(messages.submitButton)}
                                            show={loading}
                                            buttonType={'submit'}
                                            className={cx(s.button, s.btnPrimary)}
                                            disabled={submitting || loading}
                                            isSuffix={true}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div >
        )
    }
}

HomeSettingsForm = reduxForm({
    form: 'HomeSettingsForm',
    onSubmit: submit,
    validate
})(HomeSettingsForm);

const selector = formValueSelector('HomeSettingsForm')
const mapState = (state) => ({
    homeSectionImage1: selector(state, 'homeSectionImage1'),
    homeSectionImage2: selector(state, 'homeSectionImage2'),
    homeSectionImage3: selector(state, 'homeSectionImage3'),
    homeSectionImage4: selector(state, 'homeSectionImage4'),
    homeSectionImage5: selector(state, 'homeSectionImage5'),
    homeSectionImage6: selector(state, 'homeSectionImage6'),
    loading: state.loader.HomeSettingsForm
})

const mapDispatch = {

}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(HomeSettingsForm)));